import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { TableComponent } from 'baseComponents/TableComponent';
import { AdminPageWrapper } from 'components/layouts/AdminPageWrapper';
import { AdminErrorPage } from 'components/AdminErrorPage';
import { ColumnsType } from 'antd/es/table';
import { StoreType, useGetStoresList } from 'hooks/useGetStoresList';
import { Checkbox } from 'antd';
import { useRefreshStores } from 'hooks/useRefreshStores';
import { TextComponent } from 'baseComponents/TextComponent';
import {
  tableSorters,
  tableFilters,
} from 'baseComponents/TableComponent/table.utils';
// import { TableFilter } from 'baseComponents/TableComponent/TableFilter/TableFilter';

const columns: ColumnsType<StoreType> = [
  {
    title: 'ID',
    dataIndex: 'pj_id',
    key: 'pj_id',
    sorter: tableSorters.number('pj_id'),
    sortDirections: ['descend', 'ascend'],
    onFilter: tableFilters.includes('pj_id'),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'type',
  },
  {
    title: 'Is Active',
    dataIndex: 'is_active',
    key: 'is_active',
    render: (isActive) => <Checkbox checked={isActive} />,
  },
];

export const AdminManageStores = () => {
  const {
    data = [],
    isLoading,
    isRefetching,
    isError,
    refetch,
    error,
  } = useGetStoresList();
  const {
    mutate: refreshStores,
    isPending: isRefreshingStores,
    error: refreshError,
    isError: isRefreshError,
  } = useRefreshStores({
    onSuccess: () => {
      refetch();
    },
  });

  if (isError) {
    return (
      <AdminErrorPage
        isRefetching={isRefetching}
        refetch={refetch}
        error={error.response?.data?.message || 'Error fetching stores'}
      />
    );
  }

  return (
    <AdminPageWrapper>
      {isRefreshError && (
        <TextComponent
          styleType='danger'
          text={
            refreshError.response?.data?.message || 'Failed to refresh stores'
          }
        />
      )}
      <TableComponent
        loading={isLoading || isRefetching || isRefreshingStores}
        tableName='Manage Stores'
        dataSource={data}
        total={data.length}
        width={500}
        columns={columns}
        ctaButtons={
          <ButtonComponent
            label='Refresh'
            onClick={() => {
              refreshStores();
            }}
            appereance='primary'
            size='middle'
            style={{ maxWidth: 320 }}
            fullWidth
          />
        }
      />
    </AdminPageWrapper>
  );
};
